<p-panel header="Parámetros de la aplicación">
    <div class="ui-grid ui-fluid">
        <div class="ui-g-12">
            <form [formGroup]="modeloForm">
                <div class="ui-g form-group">
                    <p-fieldset legend="Configuración Email" [toggleable]="true">
                          <p>
                              Se configura la cuenta de correo electronico que se emplea para enviar las notificaciones.
                          </p>
                        <div class="ui-g-12 ui-md-4">
                            <label class="label-custom" for="float-input-apli-email">Email: </label>
                            <div class="ui-inputgroup">
                                <span class="ui-inputgroup-addon"><i class="fa fa-envelope-o"></i></span>
                                <input id="float-input-apli-email" type="email" placeholder="Email" size="100" formControlName="sendEmail" required pInputText>
                            </div>
                            <div *ngIf="modeloForm.controls['sendEmail'].errors && modeloForm.controls['sendEmail'].dirty">
                                <p-message severity="error" text="Email es requerido" *ngIf="modeloForm.controls['sendEmail'].errors['required']"></p-message>
                                <p-message severity="error" text="Tener un min. de 5 y max. de 100 caractares" *ngIf="modeloForm.controls['sendEmail'].errors['minlength'] || modeloForm.controls['sendEmail'].errors['maxlength'] "></p-message>
                            </div>
                        </div>
                        <div class="ui-g-12 ui-md-3">
                            <label class="label-custom" for="float-input-apli-password">Contraseña: </label>
                            <div class="ui-inputgroup">
                                <span class="ui-inputgroup-addon"><i class="fa fa-key"></i></span>
                                <input id="float-input-apli-password" type="password" placeholder="Contraseña" size="30" formControlName="sendEmailPasswordOrigen" required pPassword>
                            </div>
                            <div *ngIf="modeloForm.controls['sendEmailPasswordOrigen'].errors && modeloForm.controls['sendEmailPasswordOrigen'].dirty">
                                <p-message severity="error" text="Contraseña es requerido" *ngIf="modeloForm.controls['sendEmailPasswordOrigen'].errors['required']"></p-message>
                                <p-message severity="error" text="Tener un min. de 5 y max. de 100 caractares" *ngIf="modeloForm.controls['sendEmailPasswordOrigen'].errors['minlength'] || modeloForm.controls['sendEmailPasswordOrigen'].errors['maxlength'] "></p-message>
                            </div>
                        </div>
                        <div class="ui-g-12 ui-md-2">
                            <label class="label-custom" for="float-input-apli-port">Puerto: </label>
                            <div class="ui-inputgroup">
                                <span class="ui-inputgroup-addon"><i class="fa fa-random "></i></span>
                                <input id="float-input-apli-port" type="number" placeholder="Puerto" formControlName="sendEmailPort" required pInputText>
                            </div>
                            <div *ngIf="modeloForm.controls['sendEmailPort'].errors && modeloForm.controls['sendEmailPort'].dirty">
                                <p-message severity="error" text="Puerto es requerido" *ngIf="modeloForm.controls['sendEmailPort'].errors['required']"></p-message>
                            </div>
                        </div>
                        <div class="ui-g-12 ui-md-2">
                            <label class="label-custom" for="float-input-apli-servidor">Servidor: </label>
                            <div class="ui-inputgroup">
                                <span class="ui-inputgroup-addon"><i class="fa fa-cog"></i></span>
                                <input id="float-input-apli-servidor" type="text" placeholder="Puerto" formControlName="sendEmailHost" required pInputText>
                            </div>
                            <div *ngIf="modeloForm.controls['sendEmailHost'].errors && modeloForm.controls['sendEmailHost'].dirty">
                                <p-message severity="error" text="Servidor es requerido" *ngIf="modeloForm.controls['sendEmailHost'].errors['required']"></p-message>
                                <p-message severity="error" text="Tener un min. de 5 y max. de 100 caractares" *ngIf="modeloForm.controls['sendEmailHost'].errors['minlength'] || modeloForm.controls['sendEmailHost'].errors['maxlength'] "></p-message>
                            </div>
                        </div>

                        <div class="ui-g-12 ui-md-1">
                            <label class="label-custom" for="float-input-apli-port">SSL: </label>
                            <div class="ui-inputgroup">
                                <span class="ui-inputgroup-addon"><i class="fa fa-cog"></i></span>
                                <p-checkbox formControlName="sendEmailEnabledSSL" binary="true"></p-checkbox>
                            </div>
                        </div>

                        <div class="ui-g-12 ui-md-7">
                            <label class="label-custom" for="float-input-apli-email">Emails Receptor: </label>
                            <div class="ui-inputgroup">
                                <span class="ui-inputgroup-addon"><i class="fa fa-envelope-o"></i></span>
                                <input id="float-input-apli-email" type="email" placeholder="Email" size="100" formControlName="sendEmailReceptor" required pInputText>
                            </div>
                            <div *ngIf="modeloForm.controls['sendEmailReceptor'].errors && modeloForm.controls['sendEmailReceptor'].dirty">
                                <p-message severity="error" text="Email es requerido" *ngIf="modeloForm.controls['sendEmailReceptor'].errors['required']"></p-message>
                                <p-message severity="error" text="Tener un min. de 5 y max. de 500 caractares" *ngIf="modeloForm.controls['sendEmailReceptor'].errors['minlength'] || modeloForm.controls['sendEmailReceptor'].errors['maxlength'] "></p-message>
                            </div>
                        </div>

                    </p-fieldset>
                    <p-fieldset legend="Cerrar Presupuesto Automaticamente" [toggleable]="true">
                        <p>
                            Se establece la cantidad de días calendarios para cerrar automaticamente el Presupuesto. Se cuenta a partir de la fecha
                            de finalización del presupuesto.
                        </p>
                        <div class="ui-g-12 ui-md-4">
                            <label class="label-custom" for="float-input-apli-email">Cantidad de días para cerrar el presupuesto: </label>
                            <div class="ui-inputgroup">
                                <span class="ui-inputgroup-addon"><i class="fa fa-envelope-o"></i></span>
                                <p-inputNumber required formControlName="diasPresupuesto" mode="decimal" [min]="0" [max]="365" [minFractionDigits]="0"></p-inputNumber>
                            </div>
                            <div *ngIf="modeloForm.controls['diasPresupuesto'].errors && modeloForm.controls['diasPresupuesto'].dirty">
                                <p-message severity="error" text="Datos es requerido" *ngIf="modeloForm.controls['diasPresupuesto'].errors['required']"></p-message>
                            </div>
                        </div>
                    </p-fieldset>
                    
                    <p-fieldset legend="Noticación para la Carta Fianza" [toggleable]="true">
                        <p>
                            Se establece la cantidad de días calendarios para notificar a los responsables via correo electronico, antes de la
                            fecha de vencimiento de la carta fianza.
                        </p>
                        <div class="ui-g-12 ui-md-4">
                            <label class="label-custom" for="float-input-apli-email">Cantidad de días para enviar la notificación: </label>
                            <div class="ui-inputgroup">
                                <span class="ui-inputgroup-addon"><i class="fa fa-envelope-o"></i></span>
                                <p-inputNumber required formControlName="diasCartaFianza" mode="decimal" [min]="0" [max]="365" [minFractionDigits]="0"></p-inputNumber>
                            </div>
                            <div *ngIf="modeloForm.controls['diasCartaFianza'].errors && modeloForm.controls['diasCartaFianza'].dirty">
                                <p-message severity="error" text="Dato es requerido" *ngIf="modeloForm.controls['diasCartaFianza'].errors['required']"></p-message>
                            </div>
                        </div>
                    </p-fieldset>
                </div>
            </form>
        </div>
        
    </div>
    <div class="ui-grid ui-fluid">
        <div class="ui-g-12">
            <button pButton type="submit" [disabled]="!modeloForm.valid" label="{{globalConstants.cGrabar}}" icon="{{globalConstants.icoGrabar}}" (click)="onClickSave()"></button>
        </div>
    </div>
</p-panel>